export const environmentCircuits = {
  production: false,
  webVersion: '3.3.4',
  url: 'https://api-dev-temp.wisen.com.br/api',
  timerObservableSeconds: 60,
  helpSupport: 'https://circuits.atlassian.net/servicedesk/customer/portals',
  cloudFront: 'http://d12cs8ei5k77d6.cloudfront.net/'
};
